import { useState } from "react";

import type { ProductCategory } from "~/providers/product-provider";
import { cn } from "~/lib/utils";
import { useRegisterStore } from "~/stores/use-register-store";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { RegisterButton } from "../ui/register-button";

export function CategoryButton({
  productCategory,
  className,
  disabled,
  onClick,
}: {
  productCategory: ProductCategory;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}) {
  const { setSelectedCategoryId, selectedCategoryId } = useRegisterStore();
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setSelectedCategoryId(productCategory.id);
    if (onClick) {
      onClick();
    }
  };

  const handleContextMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
  };

  return (
    <>
      <RegisterButton
        isPressed={selectedCategoryId === productCategory.id}
        disabled={disabled}
        className={cn(
          "items-center justify-center uppercase",
          selectedCategoryId === productCategory.id && "shadow-inner",
          className,
        )}
        color={productCategory.color ?? undefined}
        onClick={handleClick}
      >
        {productCategory.name}
      </RegisterButton>
      <Dialog onOpenChange={setIsOpen} open={isOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{productCategory.name}</DialogTitle>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </>
  );
}
